import { _axios } from '../plugins/axios'
import { globals } from '../main.js'
import Configuration from '@/configuration'

const Vue = {}
Vue.axios = _axios

function makeRequest(callback) {
  return globals.$authService
    .getAccessToken()
    .then((response) => {
      callback(response)
    })
    .catch(function (error) {
      //Acquire token silent failure, send an interactive request.
      new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export default {
  async save(data, mocId) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'post',
          data: data,
          url: Configuration.value('tasksEndPoint').concat(`/api/Task/Save/${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async saveSingleTask(data) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'put',
          data: data,
          url: Configuration.value('tasksEndPoint').concat(`/api/Task/SaveSingleTask/${data.mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getAllTasksForMoc(mocId) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          body: '',
          url: Configuration.value('tasksEndPoint').concat(`/api/Task/GetAllByMocId/${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getNewTask(mocId, completedStatusText) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          body: '',
          url: Configuration.value('tasksEndPoint').concat(`/api/Task/GetNewTask/${mocId}/${completedStatusText}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getTaskByMocIdAndTaskListType(mocId, tasklistType) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('tasksEndPoint').concat(`/api/Task/GetAllByTypeForMocId/${mocId}/${tasklistType}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getTasksPendingMOCDashboardCount(communityShortName) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('tasksEndPoint').concat(`/api/Task/getTasksPendingMOCDashboardCount/${communityShortName}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async deleteAllTasksForMoc(mocId) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'delete',
          body: '',
          url: Configuration.value('tasksEndPoint').concat(`/api/Task/DeleteAllTasksForMoc/${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async saveAndCleanUpTasks(mocId, data) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'post',
          data: { mocId: mocId, tasks: data },
          url: Configuration.value('tasksEndPoint').concat(`/api/Task/CleanUpAndInsertTasks/${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async paginateTasksPendingMOCDashboard(communityShortName, params, cancelToken) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('tasksEndPoint').concat(`/api/Task/paginateTasksPendingMOCDashboard/${communityShortName}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          params,
          cancelToken
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  getTaskVersionFile(communityAbbreviation, mocId, version) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('tasksEndPoint').concat(
            `/api/Task/GetTasksVersion/${communityAbbreviation}/${mocId}/${version}`
          ),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async areAllTasksComplete(mocId) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          body: '',
          url: Configuration.value('tasksEndPoint').concat(`/api/Task/areAllTasksComplete/${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  }
}
